<template>
  <div class="pa-5">
    <AccountCardTitle :id="id" :name="name" :companyName="companyName" :blocked="blocked" />
    <AccountCardTopInfo :cnpj="cnpj" :phone="phone" :aggregateNumber="aggregateNumber"/>
    <AccountCardBottomInfo
      :address="address"
      :number="number"
      :zip="zip"
      :neighborhood="neighborhood"
      :state="state"
      :email="email"
    />
  </div>
</template>

<script>
import AccountCardTitle from "@/components/atoms/Contas/account-card-title";
import AccountCardTopInfo from "@/components/atoms/Contas/account-card-top-info";
import AccountCardBottomInfo from "@/components/atoms/Contas/account-card-bottom-info";

export default {
  components: {
    AccountCardTitle,
    AccountCardTopInfo,
    AccountCardBottomInfo
  },
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    companyName: {
      type: String,
      required: false
    },
    cnpj: {
      type: String,
      required: false
    },
    phone: {
      type: String,
      required: true
    },
    address: {
      type: String,
      required: false
    },
    number: {
      type: Number,
      required: false
    },
    zip: {
      type: [String, Number],
      required: false
    },
    neighborhood: {
      type: String,
      required: false
    },
    state: {
      type: String,
      required: false
    },
    email: {
      type: String,
      required: true
    },
    blocked: {
      type: Boolean,
      required: true
    },
    aggregateNumber: {
      type: Number,
      required: false
    }
  }
};
</script>